import React from "react";
import { COPY } from "@/data/waitlistOptions";
import { WaitlistForm } from "./WaitlistForm";
import { LANDING } from "@/constants/testIds/waitlist";

export const WaitlistSection = () => (
  <section
    data-testid={LANDING.waitlistSection}
    aria-labelledby="waitlist-heading"
    className="relative"
  >
    <div className="mx-auto max-w-xl px-6 sm:px-8 pt-12 sm:pt-16 pb-20 sm:pb-24">
      <h2
        id="waitlist-heading"
        className="font-condensed uppercase font-bold text-white text-3xl sm:text-4xl tracking-tight"
      >
        {COPY.waitlistHeading}
      </h2>
      <p className="mt-3 text-white/60 text-base">{COPY.waitlistSupport}</p>

      <div className="mt-10">
        <WaitlistForm />
      </div>
    </div>
  </section>
);
